export const PERSONAL_ADDRESS = "personal_address";
export const DHL_PACKSTATION = "dhl_packstation";
export const SELF_PICKUP = "self_pickup";
export const PRODUCT_TYPE_PRESCRIPTION_DRUG = "prescription_drug";
export const PRODUCT_TYPE_TEST_KIT = "test_kit";
export const PRODUCT_TYPE_FREE_DRUG = "free_drug";
export const SHIPPING_COMPANY_UBER = "uber";
export const SHIPPING_COMPANY_URBIFY = "urbify";
export const EXPRESS_SHIPPING_COMPANIES = [SHIPPING_COMPANY_UBER, SHIPPING_COMPANY_URBIFY];
export const RX_UPSELL_MARKETS = ['de', 'fr', 'ch'];
export const RX_UPSELL_DECLINED_KEY = 'rx_upsell_declined';

/*
  RX Self-Pickup payment models. These values mirror the server's
  constants.SERVICE_OPTIONS.PREMIUM_SERVICE / STANDARD_SERVICE — the same vocabulary the
  cart and order already use for the service the customer picked.
*/
export const SELF_PICKUP_PAYMENT_MODELS = {
  /* "Pay Once" — customer pays DoktorABC for prescription + medication. */
  PAY_ONCE: "prescription_and_medication",
  /* Customer pays DoktorABC for the prescription and the pharmacy for the medication. */
  PRESCRIPTION_ONLY: "prescription_only",
} as const;